const separator = ':';
export function buildTokenId(chainId, tokenAddress) {
    return `${chainId}${separator}${tokenAddress}`.toLowerCase();
}
export function buildTokenPriceId(chainId, tokenAddress) {
    return `${chainId}${separator}${tokenAddress}`.toLowerCase();
}
export function buildBalanceId(chainId, walletAddress, tokenAddress) {
    return `${chainId}${separator}${walletAddress}${separator}${tokenAddress}`.toLowerCase();
}
export function destructuringId(id) {
    return id.split(separator);
}
export function buildTokenIdByToken(token) {
    return buildTokenId(token.chainId, token.address);
}
//# sourceMappingURL=token-id.js.map